import { css } from 'glamor'

export default {
  animation: css({
    color: '#00c100',
    fontWeight: '900',
    transform: 'scale(2)',
  }),
}



// WEBPACK FOOTER //
// ./src/components/MistakeCount/styles.js